export default __webpack_public_path__ + "static/media/Lip_5_F.a4386b8e.svg";